import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { route } from '/@/app/routes.jsx';
import { formatDate } from "/@/app/utils.jsx";

export const PriceDetails = ({ plan, prefix }) => {
    const { t } = useTranslation();

    return(
        <Typography
            variant="body1"
            component="div"
            sx={{
                color: t => t.palette.primary.main,
                textAlign: 'center',
                mb: 1,
                lineHeight: '1.2em',
        }}>
            <Box sx={{ mb: 1 }}> {t(plan.status?.prolongable?'Стоимость продления':'Стоимость')+':'} </Box>
            <Box sx={{
                mb: 2,
                color: plan.discount.user_is_eligible ? "green" : "auto",
                lineHeight: '1.2em',
            }}>
                Вариант 1: {" "}
                <br />
                <Typography component="span" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    {(plan.price.RUB/100 * (100-plan.discount.percent)/100).toFixed(0)}
                    <Box component="span" sx={{ color: t => t.palette.text.primary }}>*</Box> {" "}
                    руб
                </Typography> {" "}
                <Typography component="span" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    за {prefix} {" "}
                    {
                        t({
                                day: 'price_day',
                                month: 'price_month',
                                year: 'price_year',
                            }[plan.duration_unit],
                            {count: plan.status?.prolongable?plan.duration+1:plan.duration}
                        )
                    }
                </Typography> {" "}
                <br />при условии импорта результатов обследования {" "}
                <Link component={RouterLink} to={route('/labs/')}>
                    "Тераностика 1.7" в партнерских лабораториях
                </Link>.
                <br />при условии, что обследование пройдено не ранее чем за 3 месяца до момента оплаты тарифа {" "}

                {plan.discount.user_is_eligible &&
                    <Box sx={{ fontSize: '12px', color: "green" }}>
                        Доступен, воспользуйтесь до {formatDate(plan.discount.valid_till)}.
                    </Box>
                }
            </Box>
            <Box sx={{ mb: 1, color: plan.discount.user_is_eligible ? "auto" : "green" }}>
                Вариант 2: {" "}
                <br />
                <Typography component="span" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    { (plan.price.RUB/100).toFixed(0) }
                    <Box component="span" sx={{ color: t => t.palette.text.primary }}>*</Box> {" "}
                    руб
                </Typography> {" "}
                <Typography component="span" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    за {prefix} {" "}
                    {
                        t({
                                day: 'price_day',
                                month: 'price_month',
                                year: 'price_year',
                            }[plan.duration_unit],
                            {count: plan.status?.prolongable?plan.duration+1:plan.duration}
                        )
                    }
                </Typography> {" "}
                <br />
                в других лабораториях.
            </Box>
            <Box sx={{ mb: 2, color: t => t.palette.text.primary }}>
                Цена действует до {formatDate(plan.price_valid_till)}.
            </Box>
        </Typography>
    );
}
